import React from 'react'

// One slideshow item (custom slide or news article) with its actions.
const ItemRow = ({ item, children }) => (
  <li className='flex items-center gap-3 py-2'>
    <div className='w-16 aspect-[16/9] shrink-0 rounded overflow-hidden bg-gray-200 dark:bg-gray-700'>
      {item.image_url && <img src={item.image_url} alt='' className='w-full h-full object-cover' />}
    </div>
    <div className='flex-1 min-w-0'>
      <p className='text-sm font-medium text-gray-900 dark:text-white truncate'>{item.title}</p>
      {item.subtitle && <p className='text-xs text-gray-500 dark:text-gray-400 truncate'>{item.subtitle}</p>}
    </div>
    <div className='flex items-center gap-2 shrink-0'>{children}</div>
  </li>
)

export default ItemRow
